import React, { useState } from 'react'
import { SliderProducts } from './SliderProducts'

export const SliderCollection = () => {
    return (
        <div className='w-full flex justify-center items-center mt-4 group'>
            <div className='w-full px-4 xl:p-0 xl:w-[--page-width] flex flex-col items-center justify-center relative'>
                <div className='flex flex-col w-full items-center justify-center gap-4 mb-4 lg:mb-2 '>
                    <h4 className='text-2xl font-bold'>Sản phẩm bán chạy nhất</h4>
                </div>
                <SliderProducts isCountDown={true}/>
            </div>

        </div>
    )
}
